<ng-template vdrDialogTitle>{{
  "package.bulk-add-sku" | translate
}}</ng-template>

<form>
  <vdr-form-field [label]="'package.applied-for-order' | translate">
    <div>
      <a
        *ngFor="let item of items"
        class="button-ghost"
        style="margin-right: 6px; margin-top: 6px"
        [routerLink]="['/orders', item.orderId]"
      >
        <span>{{ item.order.code }}</span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </div>
  </vdr-form-field>

  <vdr-form-field
    [label]="'common.new-sku' | translate"
    for="new-sku"
    style="margin-top: 1rem; width: 100%"
  >
    <div style="width: 100%">
      <product-variant-selector
        (productSelected)="addNewProductVariant($event)"
      ></product-variant-selector>
    </div>
  </vdr-form-field>

  <div *ngIf="newVariant" style="padding: 10px; margin-top: 6px">
    <div style="display: flex">
      <div>SKU :</div>
      <div style="margin-left: 6px">{{ newVariant.sku }}</div>
    </div>

    <div style="display: flex; margin-top: 6px">
      <div>Stock :</div>
      <div style="margin-left: 6px">{{ newVariant.stockOnHand }}</div>
    </div>
  </div>

  <vdr-form-field
    [label]="'common.quantity' | translate"
    for="quantity"
    style="width: 100%; margin-top: 1rem"
  >
    <input
      id="quantity"
      type="number"
      [formControl]="detailForm.controls.quantity"
      min="1"
      step="1"
    />
  </vdr-form-field>
</form>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button
    type="submit"
    [disabled]="!currentVariant && !newVariant"
    (click)="save()"
    class="btn btn-primary"
  >
    {{ "common.bulk-add" | translate }}
  </button>

  <button
    type="submit"
    [disabled]="!currentVariant && !newVariant"
    (click)="del()"
    class="btn btn-primary"
  >
    {{ "common.bulk-del" | translate }}
  </button>
</ng-template>
